import { Button, Card } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { useConfirmDialog } from "@chef/hooks";
import { AccountReactivationModal } from "@chef/smart-components";
import { noop } from "@chef/utils/noop";

import { RaatassOptOutSection } from "../RaatassOptOutSection";

import { intl } from "./AccountPaused.Intl";

export const AccountPaused = () => {
  const { isShowing, handleCancel, handleConfirm, handleShow } =
    useConfirmDialog();

  return (
    <>
      <AccountReactivationModal
        show={isShowing}
        onClose={handleCancel}
        handleConfirm={handleConfirm}
        redirectUrl={BRAND_PATHS.POST_REACTIVATION_LOCATION}
      />
      <div className="flex flex-col gap-6 col-span-full md:col-span-5">
        <Card>
          <div className="flex justify-between">
            <h2 className="text-xl">
              <strong>{intl.SUBSCRIPTION_STATUS}</strong>
            </h2>
            <p>
              <strong className="mb-1 p-1 px-1.5 text-xs text-white rounded-sm bg-error ">
                {intl.STATUS}
              </strong>
            </p>
          </div>

          <div className="mt-3">
            <p>
              <strong>{intl.YOUR_DELIVERIES_ARE_STOPPED}</strong>
            </p>
            <p>{intl.RESUME_DELIVERIES_AND_ENJOY_HEALTHY_RECIPES}</p>
          </div>

          <Button
            onClick={() => handleShow(noop)}
            primary
            className="mt-6 text-sm"
            small
          >
            {intl.RESUME}
          </Button>
        </Card>
        <RaatassOptOutSection />
      </div>
    </>
  );
};
